/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ukResidentSinceBirthLabel: {
        id: 'qnb.spm.yourDrivingHistory.ukResidentSinceBirthLabel',
        defaultMessage: 'Have {pronoun} been permanently resident in the UK since birth?'
    },
    ukResidentSinceBirthHelpText: {
        id: 'qnb.spm.yourDrivingHistory.ukResidentSinceBirthHelpText',
        defaultMessage: 'This will help us understand how much experience {pronoun} have of driving in the UK. If {pronoun} were a student or in the armed forces abroad, but {possessivePronoun} primary permanent residence was in the UK, this counts as being permanently resident in the UK.'
    },
    ukResidentSinceBirthHelpTextP1: {
        id: 'qnb.spm.yourDrivingHistory.ukResidentSinceBirthHelpTextP1',
        defaultMessage: 'This will help us understand how much experience {pronoun} have of driving in the UK.'
    },
    ukResidentSinceBirthHelpTextP2: {
        id: 'qnb.spm.yourDrivingHistory.ukResidentSinceBirthHelpTextP2',
        defaultMessage: 'If {pronoun} were a student or in the armed forces abroad, but {possessivePronoun} primary permanent residence was in the UK, this counts as being permanently resident in the UK.'
    },
    ukResidencyYearLabel: {
        id: 'qnb.spm.yourDrivingHistory.ukResidencyYearLabel',
        defaultMessage: 'What year did {pronoun} move (or return) to continuously reside in the UK?'
    },
    fullUkLicenceLabel: {
        id: 'qnb.spm.yourDrivingHistory.fullUkLicenceLabel',
        defaultMessage: 'Do {pronoun} hold a full UK driving licence?'
    },
    fullUkLicenceHelpTextBold: {
        id: 'qnb.spm.yourDrivingHistory.fullUkLicenceHelpTextBold',
        defaultMessage: ' So long as the DVLA is happy for {pronoun} to drive, we do not need to be made aware of any medical conditions.'
    },
    fullUkLicenceHelpText: {
        id: 'qnb.spm.yourDrivingHistory.fullUkLicenceHelpText',
        defaultMessage: 'If {pronoun} have been advised by a doctor not to drive, or have had to report a medical condition to the DVLA and have not yet received their response, please call us on {phoneNumber}.'
    },
    fullUkLicenceValidation: {
        id: 'qnb.spm.yourDrivingHistory.fullUkLicenceValidation',
        defaultMessage: 'Please select whether {pronoun} hold a full UK driving licence'
    },
    driverLicenseScopeLabel: {
        id: 'qnb.spm.yourDrivingHistory.driverLicenseScopeLabel',
        defaultMessage: 'What type of licence do {pronoun} hold?'
    },
    driverLicenseYearsLabel: {
        id: 'qnb.spm.yourDrivingHistory.driverLicenseYearsLabel',
        defaultMessage: 'How many years have {pronoun} held {possessivePronoun} licence for?'
    },
    hasAccessToOtherVehiclesLabel: {
        id: 'qnb.spm.yourDrivingHistory.hasAccessToOtherVehiclesLabel',
        defaultMessage: 'Do {pronoun} own or have regular use of another vehicle?'
    },
    UpdateNeededMessage: {
        id: 'qnb.spm.yourDrivingHistory.UpdateNeededMessage',
        defaultMessage: 'Due to changes we have made, we need some additional information to calculate your premium. Please enter required data below:'
    },
    numberOfCarsInHousehold: {
        id: 'qnb.spm.yourDrivingHistory.numberOfCarsInHousehold',
        defaultMessage: 'How many cars are registered at your address?'
    },
    insuranceDeclinedLabel: {
        id: 'qnb.spm.yourDrivingHistory.insuranceDeclinedLabel',
        defaultMessage: 'Have {pronoun} had an insurance policy declined, cancelled or made void in the last 5 years?'
    },
    insuranceDeclinedHelpText: {
        id: 'qnb.spm.yourDrivingHistory.insuranceDeclinedHelpText',
        defaultMessage: 'If {possessivePronoun} insurance was declined, cancelled or made void, (for example, as a result of providing false information), {pronoun} would have been notified by {possessivePronoun} insurer.'
    },
    insuranceDeclinedModalHeader: {
        id: 'qnb.spm.yourDrivingHistory.insuranceDeclinedModalHeader',
        defaultMessage: 'Insurance declined?'
    },
    insuranceDeclinedModalInfo: {
        id: 'qnb.spm.yourDrivingHistory.insuranceDeclinedModalInfo',
        defaultMessage: 'Insurance may be declined, cancelled or made void for various reasons including; failing to provide information or documentation when requested, providing false information or misrepresenting information, fraudulent or criminal activity.'
    },
});
